<app-loading *ngIf="contentReady"></app-loading>



<div class="bg-light" style="margin-bottom: 80px;">
  <div class="container-fluid">
    <div class="row justify-content-center">

      <app-luckywheel *ngIf="showWheel" [userId]="userId">
      </app-luckywheel>
      <app-offers style="padding: 0!important;margin-top: 15px;"></app-offers>
      <app-allpets style="padding: 0!important;"></app-allpets>



      <app-allbrands style="padding: 0!important;"></app-allbrands>
      <app-mostrated style="padding: 0!important;"></app-mostrated>
      <app-shoping style="padding: 0!important;"></app-shoping>

      <!-- <app-deals style="padding: 0!important;margin-top: 15px;"></app-deals> -->



      <app-productmostsales style="padding: 0!important;"></app-productmostsales>

      <app-productrecommendation style="padding: 0!important;"></app-productrecommendation>




    </div>
  </div>
</div>